import React from 'react';
import { useAuth } from './contexts/auth';

import SignRoutes from './SignRoutes';
import AppRoutes from './AppRoutes';

function Routes() {
  const { auth } = useAuth();
  return auth ? <AppRoutes /> : <SignRoutes />;
}

export default Routes;
